import {observer} from 'mobx-react';
import UI from '../stores/UI'
import Arrow from '../svg/Arrow'
import Spinner from '../svg/Spinner'

class Cursor extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      show: false,
      top: 0,
      left: 0,
      isNext: true
    }
  }

  componentWillMount() {
    // window.addEventListener('focus', this.updatePosition)
    window.addEventListener('mousemove', this.updatePosition)
    document.body.addEventListener('mouseleave', this.hideCursor)
  }

  componentWillUnmount() {
    window.removeEventListener('mousemove', this.updatePosition, false)
    // window.removeEventListener('focus', this.updatePosition, false)
    document.body.removeEventListener('mouseleave', this.hideCursor, false)
  }

  updatePosition = e => {
    this.setState({
      show: true,
      top: e.clientY,
      left: e.clientX,
      isNext: e.clientX > (window.innerWidth * 0.5)
    })
  }

  hideCursor = e => {
    this.setState({
      show: false
    })
  }

  render() {

    const translate = `translate(${this.state.left}px, ${this.state.top}px)`

    const css = {
      display: this.state.show ? 'block' : 'none',
      position: 'fixed',
      top: 0,
      left: 0,
      transform: this.props.isDown ? `${translate} rotate(-90deg)` : this.state.isNext ? `${translate} rotate(180deg)` : `${translate} rotate(0)`,
      zIndex: 100,
      cursor: "none"
    }

    return (
      <div style={css}>
        {UI.isLoading ? <Spinner fill={this.props.fill} /> : <Arrow fill={this.props.fill} />}
      </div>
    )
  }
}

export default observer(Cursor)



// WEBPACK FOOTER //
// ./app/javascript/packs/components/Cursor.js